import React from 'react';
import { ContentObjective, ObjectiveDescriptions } from '../../types/socialContent';

const ObjectiveSelector = ({ value, onChange }) => {
    return (
        <div className="bg-white rounded-lg shadow-sm p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
                ¿Cuál es tu objetivo?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {Object.entries(ContentObjective).map(([key, objectiveValue]) => {
                    const description = ObjectiveDescriptions[objectiveValue];
                    return (
                        <div
                            key={objectiveValue}
                            onClick={() => onChange(objectiveValue)}
                            className={`border rounded-lg p-4 cursor-pointer transition-all ${value === objectiveValue
                                    ? 'border-blue-500 bg-blue-50 shadow-md'
                                    : 'border-gray-200 hover:border-blue-300 hover:shadow'
                                }`}
                        >
                            <h4 className="font-semibold text-gray-900 mb-2">
                                {description.title}
                            </h4>
                            <p className="text-sm text-gray-600 mb-3">
                                {description.description}
                            </p>
                            <div className="space-y-1">
                                {description.examples.map((example, index) => (
                                    <div
                                        key={index}
                                        className="text-xs text-gray-500 flex items-center"
                                    >
                                        <span className="w-1 h-1 bg-blue-500 rounded-full mr-2"></span>
                                        {example}
                                    </div>
                                ))}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default ObjectiveSelector; 